module.exports = __webpack_public_path__ + "img/product.27cf827e.jpg";